import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocumentEnum } from 'src/app/services/documentsOperation/DocumentEnum';
import { DocDialogComponent } from '../doc-dialog/doc-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { S3ServiceService } from 'src/app/services/s3Service/s3-service.service';
import { observableToPromise } from 'src/app/services/ObservableToPromise';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GenericConfirmationDialogComponent } from 'src/app/core/generic-confirmation-dialog/generic-confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';

@Component({
  selector: 'app-doc-card',
  templateUrl: './doc-card.component.html',
  styleUrls: ['./doc-card.component.scss'],
})
export class DocCardComponent implements OnInit {
  DocumentEnum: any;
  docTypeText: string;
  docSvgLoc: string;
  document_url: string;
  document_view_url: SafeResourceUrl;
  document_download_url: string;
  private urlFetchedAt: number;
  private urlValidDurationMs = 15 * 60 * 1000; // 10 minutes
  @Output() updateDocumentList = new EventEmitter<boolean>();

  @Input() documentDetails: any;
  @Output() refreshDocuments = new EventEmitter<void>();
  @ViewChild('content10') content10!: TemplateRef<any>;
  logo: string;

  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    private s3Service: S3ServiceService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private documentService: DocumentsService
  ) {}

  ngOnInit(): void {
    this.getSvgImageType();
  }

  openCardDialog(type: string) {
    // let array = [this.documentDetails.documentType, text, isDelete, isView];
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '75vw';
    dialogConfig.height = '50vh';

    dialogConfig.data = {
      type: type,
      document: this.documentDetails,
    };    
    
    dialogConfig.panelClass = 'activate-employee';
    const dialogRef = this.dialog.open(DocDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data) => {
      if (data.isUploaded) {
        this.updateDocumentList.emit(true);
      }
    });
  }

  openDeleteConfirmationDialog(documentDetails: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      header: 'Delete Document',
      text: 'Are you sure you want to delete this document?',
    };
    dialogConfig.panelClass = 'activate-employee';
    this.dialog
      .open(GenericConfirmationDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res === 'Yes') {
          this.s3Service.deleteFileById(documentDetails.id).subscribe(
            (res: any) => {
              this.documentService.triggerDocumentRefresh();
            },
            (e: any) => {
              this.toastrService.error('Cannot delete docuement: ' + e.message);
            }
          );
        }
      });
  }

 getFormattedType(value: string): string {
  const words = value.toLowerCase().split('_');
  return words
    .map((word) => {
      if(word === 'pan') return 'PAN';
      if(word === 'id') return 'ID';
      if(word==='license') return 'License';
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
  }

  getSvgImageType() {
    if (this.documentDetails.documentType == DocumentEnum.AADHAAR) {
      this.docTypeText = 'Aadhaar Card';
      this.docSvgLoc = '../../../../assets/icons//aadhaar-1-blue-no-text.svg';
    }
    if (this.documentDetails.documentType == DocumentEnum.PAN) {
      this.docTypeText = 'PAN Card';
      this.docSvgLoc = '../../../../assets/icons/card_14084369.png';
    }
    if (this.documentDetails.documentType == DocumentEnum.ADDRESS_PROOF) {
      this.docTypeText = 'Proof of Address';
      this.docSvgLoc = '../../../../assets/icons/home_work_24dp_0081FF_FILL0_wght400_GRAD0_opsz24.svg';
    }
    if (this.documentDetails.documentType == DocumentEnum.VOTER_ID) {
      this.docTypeText = 'Voter ID';
      this.docSvgLoc =
        '../../../../assets/icons/ChatGPT Image May 14, 2025, 12_32_32 AM.png';
    }
  }

  async open(content10) {
    if (!this.document_view_url) {
      await this.downloadFromS3WithBlob();
    }
    if (this.document_view_url) {
      this.modalService
        .open(content10, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {},
          (reason) => {}
        );
    } else {
      console.error('Failed to load file preview');
    }
  }

  async downloadFile() {
    if (!this.document_download_url) {
      await this.downloadFromS3WithBlob();
    }

    if (this.document_download_url) {
      const anchor = document.createElement('a');
      anchor.href = this.document_download_url;

      // Extract original file name
      const originalFileName = this.documentDetails.document_name.split('/').at(-1); // e.g., "BA00128_Yash Moharil.png"

      // Find last dot to separate name and extension
      const dotIndex = originalFileName.lastIndexOf('.');
      const namePart = originalFileName.substring(0, dotIndex);  
      const extension = originalFileName.substring(dotIndex); 
      const newNamePart=namePart.replace('_',' - ');

      // Construct new filename
      const formattedFileName = `${newNamePart} - ${this.docTypeText}${extension}`;

      anchor.download = formattedFileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

    } else {
      console.error('Failed to Download file');
    }
  }

  async downloadFromS3WithBlob(): Promise<void> {
    const now = Date.now();
    if (
      this.document_download_url &&
      this.urlFetchedAt &&
      now - this.urlFetchedAt < this.urlValidDurationMs
    ) {
      return; // Use cached blob URL
    }

    try {
      const response = await observableToPromise(
        this.s3Service.getGetPresignedUrl(
          this.documentDetails.cloud_storage_path
        )
      );

      this.document_url = response.body.url;
      this.urlFetchedAt = now;

      const res = await fetch(this.document_url);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);

      this.document_view_url = this.sanitizeBlobUrl(objectUrl);
      
      this.document_download_url = objectUrl;
    } 
    catch (err) {
      console.error('Failed to download from S3:', err);
      this.document_view_url = null;
      this.document_download_url = null;
    }
  }

  sanitizeBlobUrl(blobUrl: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }
}
